export const headers = {
  'X-KW-Header': '73fd62a4c6c4110709ddfcad6d173c263402b14f28065864bb9d34c448d62937'
};

export const pageSize = 10;
